import { AbsgArrayHelper } from '@absg/angular-common';
import { IIconProvider, IStatusProvider } from '@absg/angular-components';
import { FormularyType } from '@absg/nim-client-shared';

export class ItemPillExtendedView implements IStatusProvider, IIconProvider {

  itemId: string;
  name: string;
  genericName: string;
  ndc: string;
  patientOwnedDemographics: string;
  patientOwnedItemTypeShortName: string;

  isDiscontinued?: boolean;
  isReturned: boolean;
  isWasted: boolean;
  formularyTypeId: number;
  isInsufficientQuantity: boolean;
  isBuyIn: boolean;
  is340B: boolean;
  patientOwnedId: number;
  isFluVaccine: boolean;
  isItem505b2: boolean;
  isUnassigned: boolean;
  isFormularyUnAssigned: boolean;
  isPracticeUnAssigned: boolean;
  isWitness: boolean;

  isPracticeFavorite: boolean;
  isRefrigerated: boolean;
  isBin: boolean;
  isAuditFavorite: boolean;
  suppressBinIcon: boolean;
  //#region  StatusPill
  isUnassignedStatus(): boolean {
    return this.isUnassigned;
  }

  isFormularyUnAssignedStatus(): boolean {
    return this.isFormularyUnAssigned;
  }

  isPracticeUnAssignedStatus(): boolean {
    return this.isPracticeUnAssigned;
  }

  isDiscontinuedStatus(): boolean {
    return !!this.isDiscontinued && !this.isPatientOwnedStatus();
  }

  isReturnedStatus(): boolean {
    return this.isReturned;
  }

  isWastedStatus(): boolean {
    return this.isWasted;
  }

  isFluVaccineStatus(): boolean {
    return this.isFluVaccine;
  }

  isPracticeStatus(): boolean {
    return this.formularyTypeId === FormularyType.PracticeOwnedItem;
  }

  isInsufficientQuantityStatus(): boolean {
    return this.isInsufficientQuantity;
  }

  isBuyInStatus(): boolean {
    return this.isBuyIn;
  }
  is340BStatus(): boolean {
    return this.is340B;
  }
  isPatientOwnedStatus(): boolean {
    return !AbsgArrayHelper.isNil(this.patientOwnedId);
  }
  isItem505b2Status(): boolean {
    return this.isItem505b2;
  }
  //#endregion StatusPill

  // #region Icons
  isItemPracticeFavorite(): boolean {
    return this.isPracticeFavorite;
  }
  isItemRefrigerated(): boolean {
    return this.isRefrigerated;
  }
  isBinned(): boolean {
    return this.isBin;
  }
  isItemAuditFavorite(): boolean {
    return this.isAuditFavorite;
  }
  itemSuppressBinIcon(): boolean {
    return this.suppressBinIcon;
  }
  //#endregion Icons
}
